import { type LabelHTMLAttributes } from "react"
import { cn } from "../../lib/utils"

export function Label({ className, children, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label className={cn("text-sm font-medium text-ink-800 dark:text-ink-200 block mb-1.5", className)} {...props}>
      {children}
    </label>
  )
}
